import { useEffect } from 'react';
import Header from '../../components/feature/Header';

const ProjectsPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const projects = [
    {
      title: 'Downtown Commercial Complex',
      category: 'commercial',
      location: 'City Center',
      year: '2024',
      description: 'A state-of-the-art commercial complex featuring modern architecture, sustainable design, and premium facilities.',
      image: 'https://public.readdy.ai/ai/img_res/a8ec673bbb9425d01fc2b2542cda03d1.jpg',
      stats: { area: '50,000 sqm', duration: '18 months', value: '$25M' },
    },
    {
      title: 'Luxury Residential Towers',
      category: 'residential',
      location: 'Waterfront District',
      year: '2024',
      description: 'Twin luxury residential towers with panoramic views, premium amenities, and sustainable living spaces.',
      image: 'https://readdy.ai/api/search-image?query=modern%20luxury%20residential%20apartment%20towers%20high-rise%20buildings%20contemporary%20architecture%20glass%20balconies%20urban%20development%20professional%20photography%20bright%20daylight%20clean%20minimalist%20background&width=800&height=600&seq=raissy-project-residential-802&orientation=landscape',
      stats: { area: '75,000 sqm', duration: '24 months', value: '$40M' },
    },
    {
      title: 'Industrial Manufacturing Facility',
      category: 'industrial',
      location: 'Industrial Zone',
      year: '2023',
      description: 'Large-scale manufacturing facility with advanced infrastructure and efficient operational design.',
      image: 'https://readdy.ai/api/search-image?query=modern%20industrial%20manufacturing%20facility%20warehouse%20building%20steel%20structure%20professional%20construction%20large-scale%20factory%20bright%20daylight%20clean%20minimalist%20background&width=800&height=600&seq=raissy-project-industrial-803&orientation=landscape',
      stats: { area: '100,000 sqm', duration: '20 months', value: '$35M' },
    },
    {
      title: 'Highway Bridge Construction',
      category: 'infrastructure',
      location: 'Regional Highway',
      year: '2023',
      description: 'Major highway bridge project connecting key transportation routes with modern engineering solutions.',
      image: 'https://readdy.ai/api/search-image?query=completed%20modern%20highway%20bridge%20infrastructure%20concrete%20pillars%20steel%20structure%20civil%20engineering%20project%20professional%20photography%20bright%20daylight%20clean%20minimalist%20background&width=800&height=600&seq=raissy-project-bridge-804&orientation=landscape',
      stats: { length: '2.5 km', duration: '16 months', value: '$30M' },
    },
    {
      title: 'Shopping Mall Development',
      category: 'commercial',
      location: 'Suburban Area',
      year: '2023',
      description: 'Modern shopping mall with retail spaces, entertainment facilities, and ample parking infrastructure.',
      image: 'https://readdy.ai/api/search-image?query=modern%20shopping%20mall%20exterior%20contemporary%20architecture%20retail%20complex%20glass%20facade%20professional%20construction%20project%20bright%20daylight%20clean%20minimalist%20background&width=800&height=600&seq=raissy-project-mall-805&orientation=landscape',
      stats: { area: '60,000 sqm', duration: '22 months', value: '$45M' },
    },
    {
      title: 'Residential Community',
      category: 'residential',
      location: 'Green Valley',
      year: '2022',
      description: 'Integrated residential community with villas, townhouses, and comprehensive amenities.',
      image: 'https://readdy.ai/api/search-image?query=modern%20residential%20community%20housing%20development%20suburban%20neighborhood%20contemporary%20homes%20landscaping%20professional%20photography%20bright%20daylight%20clean%20minimalist%20background&width=800&height=600&seq=raissy-project-community-806&orientation=landscape',
      stats: { units: '250 units', duration: '30 months', value: '$50M' },
    },
    {
      title: 'Logistics Warehouse Complex',
      category: 'industrial',
      location: 'Port Area',
      year: '2022',
      description: 'Advanced logistics and warehousing facility with modern storage and distribution systems.',
      image: 'https://readdy.ai/api/search-image?query=large%20modern%20warehouse%20logistics%20center%20distribution%20facility%20organized%20storage%20professional%20industrial%20building%20bright%20daylight%20clean%20minimalist%20background&width=800&height=600&seq=raissy-project-warehouse-807&orientation=landscape',
      stats: { area: '80,000 sqm', duration: '14 months', value: '$28M' },
    },
    {
      title: 'Urban Road Network',
      category: 'infrastructure',
      location: 'City Expansion',
      year: '2022',
      description: 'Comprehensive road network development including highways, intersections, and utilities.',
      image: 'https://readdy.ai/api/search-image?query=modern%20urban%20road%20construction%20highway%20development%20asphalt%20paving%20civil%20engineering%20infrastructure%20project%20professional%20photography%20bright%20daylight%20clean%20minimalist%20background&width=800&height=600&seq=raissy-project-roads-808&orientation=landscape',
      stats: { length: '15 km', duration: '18 months', value: '$38M' },
    },
    {
      title: 'Corporate Headquarters',
      category: 'commercial',
      location: 'Business District',
      year: '2021',
      description: 'Premium corporate headquarters with modern design, smart building systems, and sustainable features.',
      image: 'https://readdy.ai/api/search-image?query=modern%20corporate%20office%20building%20headquarters%20glass%20facade%20contemporary%20architecture%20professional%20business%20building%20bright%20daylight%20clean%20minimalist%20background&width=800&height=600&seq=raissy-project-corporate-809&orientation=landscape',
      stats: { area: '35,000 sqm', duration: '20 months', value: '$32M' },
    },
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section */}
      <section className="relative h-[60vh] flex items-center justify-center">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=impressive%20construction%20projects%20portfolio%20multiple%20completed%20buildings%20infrastructure%20development%20professional%20corporate%20photography%20bright%20daylight%20clean%20minimalist%20background&width=1920&height=800&seq=raissy-projects-hero-810&orientation=landscape"
            alt="Our Projects"
            className="w-full h-full object-cover object-center"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
        <div className="relative z-10 text-center text-white px-6">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">Our Projects</h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto">
            Showcasing Excellence in Construction and Development
          </p>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="py-24 bg-[#f5f5f5]">
        <div className="container mx-auto px-8 lg:px-12 max-w-[1140px]">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {projects.map((project, index) => (
              <div
                key={index}
                className="bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-xl transition-shadow group"
              >
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                  <div className="absolute top-4 right-4">
                    <span className="bg-white text-[#1a1a1a] px-4 py-2 rounded-md text-xs font-semibold">
                      {project.year}
                    </span>
                  </div>
                </div>
                <div className="p-6">
                  <div className="flex items-center text-sm text-[#4a4a4a] mb-3">
                    <i className="ri-map-pin-line mr-2"></i>
                    <span>{project.location}</span>
                  </div>
                  <h3 className="text-xl font-bold text-[#1a1a1a] mb-3">
                    {project.title}
                  </h3>
                  <p className="text-[#4a4a4a] mb-4 leading-relaxed">
                    {project.description}
                  </p>
                  <div className="border-t border-gray-200 pt-4 mt-4">
                    <div className="grid grid-cols-3 gap-4 text-center">
                      {Object.entries(project.stats).map(([key, value]) => (
                        <div key={key}>
                          <div className="text-sm font-semibold text-[#0891b2]">
                            {value}
                          </div>
                          <div className="text-xs text-[#4a4a4a] capitalize mt-1">
                            {key}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-8 lg:px-12 max-w-[1140px] text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-[#1a1a1a] mb-6">
            Have a Project in Mind?
          </h2>
          <p className="text-lg text-[#4a4a4a] mb-8 max-w-2xl mx-auto">
            Let's discuss how we can bring your vision to life with our expertise and experience
          </p>
          <a
            href="/contact"
            className="inline-block bg-[#0891b2] text-white px-10 py-4 rounded-md text-base font-semibold hover:bg-[#0e7490] transition-colors whitespace-nowrap cursor-pointer"
          >
            Start Your Project
          </a>
        </div>
      </section>
    </div>
  );
};

export default ProjectsPage;
